import { cn } from "../lib/css";

const Logo = ({ className }: { className?: string }) => {
  return (
    <div className={cn("flex items-center gap-1", className)}>
      <div className="size-6.5 rounded-sm bg-[linear-gradient(var(--gradient-primary),var(--gradient-primary-end))] flex items-center justify-center">
        <span className="font-display font-bold text-sm text-primary-foreground">
          MT
        </span>
      </div>
      <span className="font-display font-semibold text-lg tracking-tight">
        Monument
      </span>
    </div>
  );
};

export default Logo;
